'use client';

import { Children, createContext, type ReactNode, useContext, useMemo } from 'react';
import TableHeaderCell from './TableHeaderCell';
interface TableContext {
  head: React.ReactNode;
  mobileHead: React.ReactNode;
}
const tableContext = createContext<TableContext>({
  head: null,
  mobileHead: null
});
export const useTableContext = () => {
  return useContext(tableContext);
};
const headerCellsToText = (head: ReactNode): ReactNode => {
  if (head === undefined) {
    return null;
  }

  // Pitfall but unimportant enough that it should be able to fail without any issues.
  return Children.toArray((head as {
    props?: {
      children?: ReactNode;
    };
  })?.props?.children).map(a => (a as {
    props?: {
      children?: ReactNode;
    };
  })?.props?.children).map((text: ReactNode) => <TableHeaderCell key={`${text}`}>{text}</TableHeaderCell>) ?? null;
};
const TableProvider: React.FC<{
  head: ReactNode;
  children: ReactNode;
}> = props => {
  const textHeaderCells = headerCellsToText(props.head);
  const value = useMemo(() => ({
    head: props.head,
    mobileHead: textHeaderCells ?? props.head
  }) as const satisfies TableContext, [[props.head]]);
  return <tableContext.Provider value={value}>{props.children}</tableContext.Provider>;
};
export default TableProvider;